import { Dayjs } from '@mst-fe/shared/dayjs';
import { DatePicker, Form, Input } from 'antd';
import { FormInstance } from 'antd/lib';
import { useEffect } from 'react';

import { AMERICAN_DATE_FORMAT } from '../../utils/midas-constants';
import { PRODUCT_COLUMNS_TO_SEARCH } from '../_shared/advanced-search-constants';
import { AdvancedProductSearchCriteria } from './AdvancedProductSearchForm';

type ProductDataFormFieldsParams = {
  formInstance: FormInstance;
  setSearchCriteria: (searchCriteria: AdvancedProductSearchCriteria[]) => void;
  knownColumns?: string[];
};

export default function ProductDataFormFields({ formInstance, setSearchCriteria, knownColumns }: ProductDataFormFieldsParams) {
  const searchDate = Form.useWatch<Dayjs | undefined>('productSearchDate', formInstance);
  const searchFragment = Form.useWatch<string>('productSearchText', formInstance);

  useEffect(() => {
    if (!searchDate || !searchFragment || !knownColumns) {
      return;
    }

    // Make sure available columns includes the columns we need to search against
    const filteredColumnsToSearch = PRODUCT_COLUMNS_TO_SEARCH.filter(({ column }) => knownColumns.includes(column));

    if (filteredColumnsToSearch.length !== PRODUCT_COLUMNS_TO_SEARCH.length) {
      console.warn('[ProductDataForm] Known columns do not align with columns to search', {
        available: filteredColumnsToSearch.map(({ column }) => column).join(','),
        intended: PRODUCT_COLUMNS_TO_SEARCH.map(({ column }) => column).join(','),
      });
    }

    setSearchCriteria([
      {
        field: 'date',
        value: searchDate,
      },
      ...filteredColumnsToSearch.map<AdvancedProductSearchCriteria>(({ column: field, searchMethod }) => ({
        field,
        value: searchFragment,
        searchMethod,
      })),
      {
        field: 'correlation',
        value: true,
      },
    ]);
  }, [searchDate, searchFragment, setSearchCriteria, knownColumns]);

  return (
    <>
      <Form.Item
        label="Product"
        name="productSearchText"
        rules={[{ required: true, message: 'Enter a product name or ticker!' }]}
        labelAlign="left"
      >
        <Input placeholder="Enter a product name or ticker" />
      </Form.Item>
      <Form.Item label="Date" labelAlign="left" name="productSearchDate" rules={[{ required: true, message: 'Enter a search date' }]}>
        <DatePicker format={AMERICAN_DATE_FORMAT} aria-label="Date picker" />
      </Form.Item>
    </>
  );
}
